import ErrorCode from '../enums/textErrorCode';
/**
 * Getting translation text for specific error
 * @param {String} errorCode Error code string
 * @returns {String} Text string with translation
 */

export default function getErrorCodeTranslation(errorCode) {
  switch (errorCode) {
    case ErrorCode.RECOVERY_CODE_INVALID_OR_EXPIRED:
      return 'error.recoveryCodeInvalidOrExpired';

    case ErrorCode.RECOVERY_CODE_ERROR:
      return 'error.recoveryCodeError';

    case ErrorCode.SAVE_PASSWORD_ERROR:
      return 'error.savePasswordError';

    case ErrorCode.RECOVER_BY_EMAIL_ERROR:
      return 'error.recoverByEmailError';

    case ErrorCode.RECOVER_BY_EMAIL_INVALID:
      return 'error.recoverByEmailInvalid';

    case ErrorCode.RECOVER_BY_PHONE_ERROR:
      return 'error.recoverByPhoneError';

    case ErrorCode.RECOVER_BY_PHONE_INVALID:
      return 'error.recoverByPhoneInvalid';

    default:
      return '';
  }
}
/**
 * Getting description text for specific error. Currently only necessary for one case
 * @param {String} errorCode Error code string
 * @returns {String} Text string with translation
 */

export function getErrorCodeDescription(errorCode) {
  switch (errorCode) {
    case ErrorCode.RECOVER_BY_PHONE_INVALID:
      return 'error.recoverByPhoneInvalidDescr';

    default:
      return '';
  }
}